import { BpLink } from '../../../../shared/components/text/link/BpLink'
import React from 'react'

interface AdsCountCellProps {
  ads_count: string
  project_id: number | string
  keyword: string
}

export const AdsCountCell = ({ ads_count, project_id, keyword }: AdsCountCellProps) => {
  return <BpLink to={`ads-keyword/${project_id}/${keyword}`}>{ads_count}</BpLink>
}
